import { Button, CircularProgress, Dialog, FormControl, InputLabel, MenuItem, Select, Stack } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { StyledDialogContent, StyledDialogFooter, StyledDialogTitle } from "../../../components/Dialog.styled";
import { isEmpty } from "remeda";
import axios from "axios";
import constants from "../../../constants";
import { User } from "../../../redux/user";
import CloseModalButton from '../../../components/CloseModalButton'

interface SurveyModalProps {
  open: boolean;
  handleClose: () => void;
  save: (unEnroll: boolean) => void;
  currentUser?: User | null;
}

interface FormData {
  answer: string;
}

const initialFormDataState: FormData = {
  answer: ''
}

interface Answer {
  answerId: number;
  answer: string;
}

interface Question {
  questionId: number;
  question: string;
  answers: Answer[];
}

const SurveyModal: React.FC<SurveyModalProps> = ({
  open,
  handleClose,
  save,
  currentUser
}) => {
  const [formData, setFormData] = useState(initialFormDataState);
  const [question, setQuestion] = useState<Question>({} as Question);
  const [loading, setLoading] = useState(false);

  const getQuestion = async () => {
    try {
      const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/user-surveys/questions?category=tbr`);
      setQuestion(response.data[0]);
    } catch (error) {
      console.error(error)
    }
  }

  useMemo(() => {
    if(open) {
      getQuestion();
    }
  }, [open])

  const handleEditChange = (field: string, value: string) => {
    setFormData({
      ...formData,
      [field]: value
    });
  }

  const handleConfirm = async () => {
    try {
      setLoading(true);
      const payload = {
        userId: currentUser?.login_user_id,
        questionId: question.questionId,
        answerId: formData.answer
      }
      await axios.post(`${constants.ONTRAQ_API_URL}/api2/user-surveys`, payload);
      save(true);
      setFormData(initialFormDataState);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }

  const onClose = () => {
    setFormData(initialFormDataState);
    handleClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <CloseModalButton handleClose={handleClose} />
      <StyledDialogTitle>Ontraq Survey</StyledDialogTitle>
      <StyledDialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <FormControl size="small">
            <InputLabel id="answer">{question.question}</InputLabel>
            <Select
              size="small"
              labelId="answer"
              label={question.question}
              value={formData.answer}
              onChange={e => handleEditChange("answer", e.target.value)}
              fullWidth
            >
              <MenuItem value="" disabled>Please choose one</MenuItem>
              {
                question.answers?.map(answer => (
                  <MenuItem key={answer.answerId} value={answer.answerId}>{answer.answer}</MenuItem>
                ))
              }
            </Select>
          </FormControl>
        </Stack>
        <StyledDialogFooter>
          <Button disabled={isEmpty(formData.answer) || loading} variant="contained" onClick={handleConfirm}>
            {!loading ? ('Confirm Unenrollment') : (<CircularProgress size="30px" />)}
          </Button>
        </StyledDialogFooter>
      </StyledDialogContent>
    </Dialog>
  );
}


export default SurveyModal;